import {
    apiConstants,
    config,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest
} from "../../../Utilities/Api";
import {userData} from "../userMockData";

class ServerUserProfileApi {
    static getUserDetails(patronId: string, userId: string) {
        return sendRequest(
            requestOptions(config.URL + `patrons/${patronId}/${userId}`,
                requestTypes.GET,
            ),
        );
    }

    static editUserDetails(userDetailsModel: Record<string, unknown>, adminUserId: string) {
        return sendRequest(
            requestOptions(config.URL + `patrons/${adminUserId}`,
                requestTypes.PUT,
                JSON.stringify(userDetailsModel),
                apiConstants.successMessage.user.UPDATE
            ),
        );
    }
}

//************************************************** MOCK API SERVER CALLS ****************************************

class MockUserProfileApi {
    static getUserDetails() {
        return mockResolveApiCall(userData[0], "");
    }

    static editUserDetails() {
        return mockResolveApiCall("");
    }
}

export const userProfileApi = config.environment.MODE === config.modes.SERVER ? ServerUserProfileApi : MockUserProfileApi;
